import React from "react";

const RepliesColumn = (props) => {
    const {replyinfo} = props;
    return(
        <div className="column">
            <div className="block-title bg-1">Replies</div>
            <ul>
                <li>
                    <span className="data-value">{replyinfo?.reply + replyinfo?.bounce}</span>
                    <span className="data-label">Received</span>
                </li>
                <li className="p-0">
                    <ul>
                        <li>
                            <span className="data-value">{replyinfo?.reply}</span>
                            <span className="data-label">Replies</span>
                        </li>
                        <li>
                            <span className="data-value">{replyinfo?.bounce}</span>
                            <span className="data-label">Bounces</span>
                        </li>
                    </ul>
                </li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    );
}

export default RepliesColumn;